import { render, staticRenderFns } from "./BikePlanetOrders.vue?vue&type=template&id=669a62a5"
import script from "./BikePlanetOrders.vue?vue&type=script&lang=js"
export * from "./BikePlanetOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports